import { render } from "./DashboardDropdown.vue?vue&type=template&id=36958ed1&scoped=true"
import script from "./DashboardDropdown.vue?vue&type=script&lang=ts"
export * from "./DashboardDropdown.vue?vue&type=script&lang=ts"

import "./DashboardDropdown.vue?vue&type=style&index=0&id=36958ed1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36958ed1"

export default script